// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unset-m-width[data-v-6c01016a]{max-width:unset}@media screen and (max-width:576px){.unset-m-width[data-v-6c01016a]{max-width:80vw}}.hover-link[data-v-6c01016a]{cursor:pointer}.hover-link[data-v-6c01016a]:hover{text-decoration:underline;background-color:hsla(0,0%,80%,.3137254902)}", ""]);
// Exports
module.exports = exports;
